import { render, staticRenderFns } from "./SacEtiquetas.vue?vue&type=template&id=14191046"
import script from "./SacEtiquetas.vue?vue&type=script&lang=js"
export * from "./SacEtiquetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports